import React from 'react';
import AudioSeries from './AudioSeries';
import AudioBanner from './AdventureAudioSeries';
import BottomBanner from './BottomBanner';
import './Components/CSS/AudioSeriesMain.module.css';
import Footer from '../common/UI/Footer';
import Loading from '../common/HousGlass Loader/Loading';
import { useAudiosByAudioType } from '../hooks/useAudiosHooks';

function AudioSeriesMain() {
  // Use the new hook to fetch audio series data
  const { data, isLoading, error } = useAudiosByAudioType('Audio Series');
  
  // Loading state
  if (isLoading) {
    return <div className="loading-container"><Loading/></div>;
  }
  
  // Error state
  if (error) {
    return <div className="error-container">Failed to load audio content</div>;
  }

  // Check if data exists and has the expected structure
  if (!data || !data.data || !Array.isArray(data.data)) {
    return <div className="error-container">No audio series available</div>;
  }

  const audioSeries = data.data.map(item => ({
    id: item.id,
    title: item.series_title || item.title,
    description: item.description,
    slug: item.slug,
    coverImageUrl: item.series_cover_image || item.mobile_image_url || item.computer_image_url,
    isPremium: item.is_premium || false,
    category: { name: item.genre_name || 'Audio' },
    seriesType: 'Audio Series',
    creator: { name: 'Unknown Creator' },
    isFeatured: false // Assuming no featured flag in the data
  }));

  // Divide the series data for different components
  // Since we don't have isFeatured in the data, we'll just split the series for demonstration
  const featuredSeries = audioSeries.slice(0, Math.min(4, audioSeries.length));
  const regularSeries = audioSeries.slice(0, Math.min(5, audioSeries.length));
  
  return (
    <>
      <AudioSeries
        series={audioSeries.slice(0, 4)}
        loading={isLoading}
        pagination={data.pagination}
      />
      <AudioBanner
        series={featuredSeries.length > 0 ? featuredSeries : audioSeries.slice(0, 8)}
        loading={isLoading}
      />
      <BottomBanner
        series={regularSeries.length > 0 ? regularSeries : audioSeries.slice(0, 5)}
        loading={isLoading}
      />
      <Footer />
    </>
  );
}

export default AudioSeriesMain;